export default __webpack_public_path__ + "static/media/element_36.7f78b5e9.jpg";